import { Link } from "react-router-dom";
import { Battery, Wrench, Package } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="mt-20 border-t border-zinc-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <img src="/logo.png" alt="Mobile Xpressed" className="h-9 w-auto object-contain" />
            <div className="font-display font-extrabold tracking-tight text-zinc-900">Mobile Xpressed</div>
          </div>
          <p className="text-sm text-zinc-500 leading-relaxed max-w-xs">{t("footer.tagline")}</p>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-4">{t("footer.shop")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="text-zinc-700 hover:text-brand inline-flex items-center gap-1.5"><Wrench className="w-3.5 h-3.5" /> {t("nav.repairServices")}</Link></li>
            <li><Link to="/shop?category=Batteries" className="text-zinc-700 hover:text-brand inline-flex items-center gap-1.5"><Battery className="w-3.5 h-3.5" /> {t("nav.batteries")}</Link></li>
            <li><Link to="/shop?category=Parts" className="text-zinc-700 hover:text-brand inline-flex items-center gap-1.5"><Package className="w-3.5 h-3.5" /> {t("nav.parts")}</Link></li>
            <li><Link to="/shop?category=Accessories" className="text-zinc-700 hover:text-brand">{t("nav.accessories")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-4">{t("footer.services")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services#repair-intake" className="text-zinc-700 hover:text-brand">{t("footer.bookRepair")}</Link></li>
            <li><Link to="/services" className="text-zinc-700 hover:text-brand">{t("footer.diagnostics")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-4">{t("footer.account")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/login" className="text-zinc-700 hover:text-brand">{t("footer.signIn")}</Link></li>
            <li><Link to="/register" className="text-zinc-700 hover:text-brand">{t("footer.register")}</Link></li>
            <li><Link to="/account" className="text-zinc-700 hover:text-brand">{t("footer.orders")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-200">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 text-xs text-zinc-500 flex flex-col sm:flex-row items-center justify-between gap-2">
          <div>© {new Date().getFullYear()} Mobile Xpressed. {t("footer.copyright")}</div>
          <div className="uppercase tracking-[0.2em]">{t("footer.motto")}</div>
        </div>
      </div>
    </footer>
  );
}
